import Vue from "vue"
Vue.mixin({
  methods: {
    // 计算几天之前 val = -7  几天之后 val = 7
    // 2019-10-31
    FORMAT_YMD(val) {
      var date1 = new Date(),
        time1 = date1.getFullYear() + '-' + (date1.getMonth() + 1) + '-' + date1.getDate(); //time1表示当前时间
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + val);
      var time2 = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate();
      return time1, time2
    },
    FORMAT_M_D(val) {
      var date1 = new Date(),
        time1 = (date1.getMonth() + 1) + '-' + date1.getDate(); //time1表示当前时间
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + val);
      var time2 = (date2.getMonth() + 1) + '-' + date2.getDate();
      return time1, time2
    },
    FORMAT_MO(val) {
      var date1 = new Date(),
        time1 = (date1.getMonth() + 1)
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + val);
      var time2 = (date2.getMonth() + 1)
      return time1, time2
    },
  }
})



// WEBPACK FOOTER //
// ./src/mixin/timer.js